module.exports = __webpack_public_path__ + "static/img/gy.b643698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tout/gy.jpg
// module id = 5ZX9
// module chunks = 1